import request from '@/utils/request'

// --------- 保险 ---------
// 获取保险table数据
export const getInsTable = params =>
  request.get('/customer-api/company-insurances/page', params)
// 删除insurance id
export const deleteIns = params =>
  request.delete(`/customer-api/company-insurances/${params.id}`)
// 通过id查询insurance信息
export const getInsDetail = params =>
  request.get(`/customer-api/company-insurances/${params.id}`)
// 添加保险
export const addIns = params =>
  request.post(`/customer-api/company-insurances`, params)
// 编辑保险
export const editIns = params =>
  request.put(`/customer-api/company-insurances/${params.id}`, params)
export const download = id =>
  request.get(
    `/customer-api/customer/attachment/download/${id}`,
    {},
    {
      responseType: 'blob',
    },
  )
